import React from 'react';

const ClassManagement = () => {
  return (
    <div className="class-management">
      <h1>Class Management</h1>
      <p>This is the class management component.</p>
    </div>
  );
};

export default ClassManagement;
